import React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { useSxStyles    } from "../styles/sxStyles";
import Grid2 from '@mui/material/Grid2';
import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";

const Dob = (props) => {
    const dob = props.dob;
    const setDob = props.setDob
    const classes = useSxStyles;

    return (
        (<Grid2
            size={{
                xs: 12,
                sm: 6,
                md: 12,
                lg: 6
            }}>
            <FormControl required fullWidth>
                <FormLabel shrink={true} sx={classes.inputLabel}>
                    Date of Birth
                </FormLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        name='dob'
                        disableOpenPicker={true}
                        disableMaskedInput={false}
                        format='MM/dd/yyyy'
                        defaultValue={null}
                        value={dob}
                        onChange={(newValue) => {
                            setDob(newValue)
                        }}
                        slotProps={{
                            textField: {
                                inputProps: {
                                    sx: classes.textbox
                                }
                            }
                        }}
                    />
                </LocalizationProvider>
            </FormControl>
        </Grid2>)
    );
}

export default Dob;
